/**
 * Returns initials for avatar when no profile photo.
 * Same rule for all roles: admin, institute, superadmin, teacher, hod.
 * - Prefer name-based initials (e.g. "Nayan Sadaphal" → "NS") so the avatar matches the user's name.
 * - Fallback to email prefix initial only when name is missing.
 * @param {{ firstName?: string, name?: string, fullName?: string, instituteName?: string, lastName?: string, email?: string } | null | undefined} user
 * @returns {string} 1-2 uppercase letters, or "U" only when no email or name.
 */
export function getAvatarInitial(user) {
  const rawName =
    user?.fullName ||
    user?.name ||
    user?.firstName ||
    user?.instituteName ||
    user?.lastName ||
    "";

  const name = String(rawName || "").trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || "";
    const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] || "") : "";
    const initials = `${first}${last}`.trim();
    if (initials) return initials.toUpperCase();
  }

  if (user?.email) {
    const emailPrefix = String(user.email).split("@")[0].trim();
    if (emailPrefix) return String(emailPrefix[0]).toUpperCase();
  }

  return "U";
}
